import { render, staticRenderFns } from "./Result-Desktop.vue?vue&type=template&id=213b613e&scoped=true"
import script from "./Result-Desktop.vue?vue&type=script&lang=js"
export * from "./Result-Desktop.vue?vue&type=script&lang=js"
import style0 from "./Result-Desktop.vue?vue&type=style&index=0&id=213b613e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213b613e",
  null
  
)

export default component.exports